export { default } from './CapcaleraMarato';
